export const convertArrayBufferToImageUrl = (
  buffer: ArrayBuffer,
  type?: string,
): string => {
  // Pages come back as PNG at full size and WebP as a thumbnail, so the type is
  // carried from the response rather than left to content sniffing.
  const blob = new Blob([buffer], type ? { type } : undefined);
  return URL.createObjectURL(blob);
};

export const getImageDimensions = (
  imageUrl: string,
): Promise<{ width: number; height: number }> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.width, height: img.height });
    img.onerror = (err) => reject(err);
    img.src = imageUrl; // Set the source of the image
  });
};
